var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"txt"},[_c('b',{staticClass:"contact"},[_vm._v(_vm._s(_vm.$t("profilefollower.Contact_Infomation")))]),_c('hr'),_c('div',{staticClass:"contact row"},[_c('div',{staticClass:"col"},[_vm._v(_vm._s(_vm.$t("profilefollower.Mobile_Phone"))+":")]),_c('div',{staticClass:"col"},[_vm._v(" "+_vm._s(_vm.info.user.phone)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }